import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';
import { useI18n } from '../../utils/i18n';
import { useBenutzerEinstellungen } from '../../services/benutzerEinstellungen';
import { erlaubteBereiche, verschiebeBereich } from '../dashboard/bereiche';
import useSofortSpeichern from './useSofortSpeichern';
import './einstellungen.css';

// #569: Abschnitt „Dashboard“ im Einstellungs-Dialog: Bereiche ein- und
// ausblenden und sortieren (dashboard/bereiche.js).
//
//   - Angeboten wird nur, was die Rolle zeigt; den Pool sehen nur Manager.
//   - Der letzte sichtbare Bereich lässt sich nicht abhaken, sonst stünde
//     das Dashboard leer da.
//   - Gespeichert werden die Listen `dashboard.ausgeblendet` und
//     `dashboard.reihenfolge`. ids, die hier nicht stehen (Rolle, spätere
//     Bereiche), bleiben in beiden erhalten.
export default function DashboardWahl({ user }) {
  const { t } = useI18n();
  const einstellungen = useBenutzerEinstellungen();
  const { speichert, speichere } = useSofortSpeichern();

  const dashboard = (einstellungen && einstellungen.dashboard) || {};
  const ausgeblendet = Array.isArray(dashboard.ausgeblendet) ? dashboard.ausgeblendet : [];
  const zustand = { siehtPool: !!user?.dbUser?.isManager, ausgeblendet, reihenfolge: dashboard.reihenfolge, showTodayCalendar: false };
  const bereiche = erlaubteBereiche(zustand);
  const sichtbar = bereiche.filter((b) => !ausgeblendet.includes(b.id));
  const bereit = !!einstellungen && !speichert;

  const schalte = (id, an) => {
    const rest = ausgeblendet.filter((x) => x !== id);
    speichere({ dashboard: { ausgeblendet: an ? rest : [...rest, id] } });
  };
  const verschiebe = (id, richtung) => {
    const neu = verschiebeBereich(zustand, id, richtung);
    if (neu) speichere({ dashboard: { reihenfolge: neu } });
  };

  return (
    <ol className="einst-bereiche">
      {bereiche.map((b, i) => {
        const name = t(b.titelKey, b.titel);
        const an = !!einstellungen && !ausgeblendet.includes(b.id);
        const letzter = an && sichtbar.length === 1;
        return (
          <li key={b.id} className="einst-bereich">
            <label className="einst-schalter" title={letzter ? t('einstellungen.letzterBereich', 'Mindestens ein Bereich bleibt sichtbar') : undefined}>
              <input type="checkbox" checked={an} disabled={!bereit || letzter} onChange={(e) => schalte(b.id, e.target.checked)} />
              <span>{name}</span>
            </label>
            <span className="einst-bereich__knoepfe">
              <button
                type="button" className="btn btn-secondary btn-sm icon-only einst-pfeil"
                disabled={!bereit || i === 0}
                onClick={() => verschiebe(b.id, -1)}
                title={t('einstellungen.nachOben', '{{name}} nach oben', { name })} aria-label={t('einstellungen.nachOben', '{{name}} nach oben', { name })}
              >
                <ArrowUp size={14} />
              </button>
              <button
                type="button" className="btn btn-secondary btn-sm icon-only einst-pfeil"
                disabled={!bereit || i === bereiche.length - 1}
                onClick={() => verschiebe(b.id, 1)}
                title={t('einstellungen.nachUnten', '{{name}} nach unten', { name })} aria-label={t('einstellungen.nachUnten', '{{name}} nach unten', { name })}
              >
                <ArrowDown size={14} />
              </button>
            </span>
          </li>
        );
      })}
    </ol>
  );
}
